import React, { useState, Fragment } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ModalFooter
} from 'reactstrap';
import classnames from 'classnames';
import { postAPI_User_Folder } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

export default function CreateFolderForm({
  visible,
  toggleModal,
  formLabel,
  propertyId,
  parentLoadData,
  status,
  userName,
  folderName,
  setFolderName,
  selectedFolder,
}) {
  const [apiState, setApiState] = useState('default');

  const handleSubmit = () => {

    if (!folderName) {
      console.log("Folder name is empty");
      return;
    }

    const body = {
      groupId: getGroupID(),
      propertyId: propertyId,
      creator: userName || 'dashboard',
      folderName: folderName,
      status: status,
      folderPath: selectedFolder,
    };


    setApiState('processing');

    AxiosAPI({
      method: 'post',
      url: postAPI_User_Folder,
      data: body
    })
      .then(res => {
        if (res?.data?.status === "Name already exist") {
          setApiState('fail');
          NotificationManager.error(
            "Folder name already exists. Please choose a different name.",
            "Error",
            3000,
            null,
            null,
            "error"
          );
          return;
        }
        else {
          setApiState('success');
          NotificationManager.success(
            "",
            "Folder created successfully",
            3000,
            null,
            null,
            "success"
          );
          toggleModal();
          parentLoadData();
          setFolderName('');
        }
      })
      .catch(error => {
        setApiState('fail');
        console.error('Error:', error.response?.data || error.message);
      });
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggleModal} >
        <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
        <ModalBody>

          <Input
            type="text"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            placeholder="Folder Name"
          />


        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleSubmit}
            className={`btn-multiple-state ${classnames({
              'show-spinner': apiState === 'processing',
              'show-success': apiState === 'success',
              'show-fail': apiState === 'fail',
            })}`}
          >
            <span className="spinner d-inline-block">
              <span className="bounce1" />
              <span className="bounce2" />
              <span className="bounce3" />
            </span>
            <span className="icon success">
              <i className="simple-icon-check" />
            </span>
            <span className="icon fail">
              <i className="simple-icon-exclamation" />
            </span>
            <span className="label">Save</span>
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
